import React from "react";

const OneADay = ({ fill, light, size }) => {
  return (
    <svg
      width={size || "72"}
      height={size || "72"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 71.7 71.7"
      className="m-1"
    >
      <g>
        <path
          fillRule="evenodd"
          d="M45.91 16.738l-10.15-.03V29.38h10.15v-.03c3.413-.09 6.172-2.879 6.172-6.292 0-3.472-2.73-6.232-6.172-6.32z"
          fill={fill}
        />
        <path
          d="M36.087 18.548v8.962h-9.23l-1.068-.03a4.455 4.455 0 01-4.303-4.451c0-2.404 1.9-4.363 4.244-4.452l1.958-.03h8.399zm1.84-1.84H27.688l-1.988.03c-3.354.148-6.054 2.908-6.054 6.29 0 3.414 2.7 6.144 6.054 6.292v.06h12.227V16.708z"
          fill={fill}
        />
        <path
          d="M35.879 71.58c-19.705 0-35.7-16.026-35.7-35.701 0-19.676 15.995-35.73 35.7-35.73 19.705 0 35.73 16.025 35.73 35.73s-16.055 35.7-35.73 35.7zm0-69.8C17.064 1.78 1.78 17.065 1.78 35.88c0 18.785 15.283 34.098 34.098 34.098 18.785 0 34.098-15.284 34.098-34.098C69.947 17.064 54.664 1.78 35.88 1.78z"
          fill={fill}
        />
        <path
          d="M15.61 43.06c0 2.345-.178 6.41-3.442 6.41-3.087 0-3.443-3.501-3.443-6.41 0-3.145.475-6.41 3.443-6.41 3.145 0 3.442 3.65 3.442 6.41zm-5.55 0c0 2.196.09 5.283 2.108 5.283 2.018 0 2.107-3.087 2.107-5.283s-.09-5.282-2.107-5.282c-2.018-.09-2.107 3.086-2.107 5.282zM23.267 49.292h-1.128l-3.175-8.398c-.208-.505-.327-1.068-.475-1.603h-.09c.06.802.15 1.603.15 2.404v7.568H17.42V36.799h1.128l3.235 8.665c.178.416.297.86.415 1.276h.06c-.03-.534-.119-1.098-.119-1.662V36.77h1.128v12.523zM29.944 37.867h-3.116v4.392h3.027v1.069h-3.027v4.896h3.116v1.068h-4.422V36.828h4.422v1.039zM30.686 43.357h2.908v1.306h-2.908v-1.306zM40.39 49.292h-1.395l-.534-2.552h-2.968l-.504 2.552h-1.395l2.76-12.464h1.217l2.819 12.464zm-2.107-3.56l-.92-4.779c-.178-.83-.238-1.691-.356-2.552h-.06c-.118.831-.237 1.692-.386 2.552l-.83 4.778h2.552zM40.39 43.357h2.908v1.306H40.39v-1.306zM44.396 36.828h1.425c2.67 0 4.421.297 4.421 6.232 0 4.897-.89 6.232-4.332 6.232h-1.514V36.828zm1.306 11.426h.386c2.522 0 2.819-1.573 2.819-5.194 0-4.273-.505-5.193-2.968-5.193h-.237v10.387zM57.75 49.292h-1.394l-.535-2.552h-2.967l-.505 2.552h-1.394l2.76-12.464h1.216l2.82 12.464zm-2.106-3.56l-.92-4.779c-.179-.83-.238-1.691-.357-2.552h-.059c-.119.831-.237 1.692-.386 2.552l-.83 4.778h2.552zM61.104 43.832v5.46h-1.306v-5.46l-2.73-7.033h1.395l1.395 4.214c.178.534.326 1.098.534 1.662h.089c.118-.594.207-1.188.415-1.751l1.365-4.125h1.395l-2.552 7.033z"
          fill={light ? "#595A5A" : "#fff"}
        />
      </g>
    </svg>
  );
};

export default OneADay;
